module.exports = __webpack_public_path__ + "img/Monte_Kope_109.2401f015.jpg";